import { NgModule } from '@angular/core'
import { EbConfigInitializerModule } from './config-initializer/eb-config-initializer.module'

@NgModule({
  imports: [EbConfigInitializerModule]
})
export class EbConfigModule {}
